const onScrollView = (element: HTMLElement, callback: () => void) => {
  const observer = new IntersectionObserver(
    entries => {
      if (entries[0].isIntersecting) {
        callback();
      }
    },
    { threshold: [1] },
  );

  observer.observe(element);

  return observer;
};

export default onScrollView;
